import { deleteCustomAlertData, getAllAlertsReports, saveAlertReport, saveCustomAlertReport, toggleAlertReportFacility as toggleAlertReportFacilityAPI } from "./api/alert-report.api";

const handleAsyncOperation = async (operation, ...args) => {
    const res = await operation(...args);
    return res;
};

const getAlertsReports = async (type) => handleAsyncOperation(getAllAlertsReports, type);
const createAlertsReport = async (body) => handleAsyncOperation(saveAlertReport, body);
const deleteCustomAlert = async (body) => handleAsyncOperation(deleteCustomAlertData, body);
const createCustomAlertsReport = async (body) => handleAsyncOperation(saveCustomAlertReport, body);
const toggleAlertReportFacilityService = async (alertReportId, facilityId, enabled) => handleAsyncOperation(toggleAlertReportFacilityAPI, alertReportId, facilityId, enabled);

export {
    getAlertsReports,
    createAlertsReport,
    createCustomAlertsReport,
    deleteCustomAlert
};

export const toggleAlertReportFacility = toggleAlertReportFacilityService;
